export const specials = [
  {
    id: "annual-gala",
    title: "年度盛典前瞻：红毯造型与高光时刻全盘点",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20golden%20stage%20with%20spotlight%20and%20red%20carpet%20at%20a%20grand%20award%20ceremony%2C%20abstract%20artistic%20style%2C%20warm%20orange%20and%20deep%20brown%20tone%2C%20cinematic%20lighting%2C%20no%20people%2C%20festive%20atmosphere&width=1200&height=600&seq=special-gala-01&orientation=landscape",
    intro:
      "一年一度的娱乐盛典即将开幕，从红毯造型到舞台高光，我们提前梳理所有看点，陪你一起见证属于这个行业的高光之夜。",
    newsIds: ["n15", "n1", "n14", "n5"],
  },
  {
    id: "city-life",
    title: "城市生活观察：那些和你我息息相关的变化",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20golden%20hour%20with%20warm%20orange%20sunlight%2C%20abstract%20minimal%20illustration%20style%2C%20clean%20geometric%20buildings%2C%20soft%20gradient%20sky%2C%20no%20text&width=1200&height=600&seq=special-city-01&orientation=landscape",
    intro:
      "地铁新线开通、老旧小区改造、高温下的清凉驿站……城市每天都在悄悄变化。这个专题带你看清这些改变背后的故事。",
    newsIds: ["n6", "n8", "n9", "n7"],
  },
  {
    id: "star-return",
    title: "回归与突破：实力派演员的荧幕新战场",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20amber%20spotlight%20on%20an%20empty%20theater%20stage%20with%20velvet%20curtains%2C%20artistic%20abstract%20photography%20style%2C%20deep%20orange%20and%20cream%20tones%2C%20soft%20grain%2C%20dramatic%20but%20calm&width=1200&height=600&seq=special-star-01&orientation=landscape",
    intro:
      "时隔多年回归小荧幕、跨界幕后做制片人、单飞后重新出发……看这些实力派如何在新的战场上完成自我突破。",
    newsIds: ["n11", "n13", "n14", "n2"],
  },
  {
    id: "viral-wave",
    title: "热梗与流量：一场关于注意力的狂欢",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20colorful%20data%20waves%20and%20bubbles%20rising%20on%20a%20warm%20cream%20background%2C%20modern%20minimal%20graphic%20style%2C%20orange%20and%20terracotta%20accent%20shapes%2C%20clean%20flat%20illustration&width=1200&height=600&seq=special-viral-01&orientation=landscape",
    intro:
      "一个热梗如何在二十四小时内席卷全网？品牌为何连夜跟风？这个专题拆解流量时代的注意力游戏。",
    newsIds: ["n16", "n18", "n17", "n5"],
  },
];